import React from "react"

class Footer extends React.Component {
	render() {
		return <footer className="page-footer">
					<div className="font-13">2020 © - Công ty Cổ Phần Mioto Việt Nam </div>
					<div />
					<div className="to-top"><i className="fa fa-angle-double-up" /></div>
				</footer>
	}
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/common/footer.js